// Accordion JS for custom div-based accordion
// Add this script to your theme after converting <details>/<summary> to <div>
document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.accordion-details');
  accordions.forEach(function (accordion) {
    var summary = accordion.querySelector('.accordion-summary');
    var content = accordion.querySelector('.accordion__content');
    // Initialize open state for accordions that start expanded (e.g. open_by_default)
    if (accordion.classList.contains('is-open') && content) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
    summary.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        content.style.maxHeight = '0';
        accordion.classList.remove('is-open');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        accordion.classList.add('is-open');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
    // Keyboard accessibility
    summary.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        summary.click();
        e.preventDefault();
      }
    });
  });
});
